// App configuration for development and test environments
export const appConfig = {
  bypassAuthHostnames: [""/*"agamic-unlyrically-creola.ngrok-free.dev"*/],
  productionHostname: "experienceapp.io",
  developmentHostname: "tujus-pwa-dev.web.app",
  localHostName: "localhost",

  testEmails: [
    "test@test.com",
    "android@test.com",
    "dev@test.com",
    "dev@experienceapp.io",
    "test@experienceapp.io",
  ],
};
